var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "forget min-h-screen flex font-sans bg-background text-on-surface"
  }, [_c('aside', {
    staticClass: "hidden lg:flex w-[400px] min-h-screen flex-shrink-0 flex-col justify-between py-16 px-12 relative overflow-hidden",
    staticStyle: {
      "background-color": "#1a2035"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "absolute top-0 right-0 w-[1px] h-full bg-gradient-to-b from-transparent via-white/10 to-transparent"
  }), _vm._m(1), _vm._m(2), _c('div', {
    staticClass: "relative z-10"
  }, [_vm._m(3), _c('p', {
    staticClass: "font-sans text-[10px] text-white/15"
  }, [_vm._v(" © " + _vm._s(new Date().getFullYear()) + ` ${$t("78a1spc", "杭州绿云软件股份有限公司")} `)])])]), _c('main', {
    staticClass: "flex-1 flex flex-col min-h-screen bg-background forget-main-scroll"
  }, [_c('header', {
    staticClass: "flex justify-between items-center px-6 lg:px-10 py-5 border-b border-border-light"
  }, [_vm._m(4), _c('div', {
    staticClass: "flex items-center space-x-6 ml-auto"
  }, [_c('FootLanguage')], 1)]), _c('div', {
    staticClass: "flex-1 flex items-start lg:items-center justify-center px-6 lg:px-8 py-8 lg:py-16"
  }, [_c('div', {
    staticClass: "w-full max-w-md forget-form-shell"
  }, [_vm._m(5), _c('div', {
    staticClass: "forget_content"
  }, [_c('div', {
    staticClass: "password_type"
  }, [_c('button', {
    staticClass: "password_type_text",
    class: [{
      password_type_checek: _vm.accountType === 'MOBILE'
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.accountType = 'MOBILE';
      }
    }
  }, [_vm._v(` ${$t("ewbd43", "手机号")} `)]), _c('button', {
    staticClass: "password_type_text",
    class: [{
      password_type_checek: _vm.accountType === 'EMAIL'
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.accountType = 'EMAIL';
      }
    }
  }, [_vm._v(` ${$t("padf2", "邮箱")} `)])]), _c('SendMessage', {
    ref: "sendMessage",
    attrs: {
      "accountType": _vm.accountType,
      "mode": "FORGET_PASSWORD",
      "labelPosition": "top"
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }), _c('Form', {
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": 100
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('password-input', {
    ref: "form",
    model: {
      value: _vm.form.pw,
      callback: function ($$v) {
        _vm.$set(_vm.form, "pw", $$v);
      },
      expression: "form.pw"
    }
  })], 1)], 1), _vm._m(6), _c('div', {
    staticClass: "forget_action"
  }, [_c('Button', {
    staticClass: "action_button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v($t("ai7i2u4", "修改密码"))]), _c('Button', {
    staticClass: "action_button cancel",
    on: {
      "click": _vm.cancle
    }
  }, [_vm._v($t("ev022", "取消"))])], 1), _c('div', {
    staticClass: "forget-form-footer font-sans text-xs"
  }, [_c('span', {
    staticClass: "sign-up-link inline-flex items-center gap-1",
    on: {
      "click": function ($event) {
        return _vm.goToOther('Login');
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("arrow_back")]), _vm._v(` ${$t("iid7444", "返回登录")} `)])])])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "absolute inset-0 opacity-[0.03]"
  }, [_c('div', {
    staticClass: "absolute top-0 left-0 w-full h-full",
    staticStyle: {
      "background-image": "repeating-linear-gradient(",
      "background-size": "24px 24px"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "relative z-10"
  }, [_c('div', {
    staticClass: "flex items-center space-x-3 mb-16"
  }, [_c('div', {
    staticClass: "w-9 h-9 rounded-lg flex items-center justify-center",
    staticStyle: {
      "background-color": "#785a1a"
    }
  }, [_c('img', {
    staticClass: "w-[22px] h-[22px]",
    attrs: {
      "src": require("@/assets/iwork-logo.png"),
      "alt": "",
      "aria-hidden": "true"
    }
  })]), _c('span', {
    staticClass: "font-serif text-white text-2xl tracking-tight"
  }, [_vm._v("iWork")])]), _c('h1', {
    staticClass: "text-4xl font-serif text-white leading-snug mb-4"
  }, [_vm._v(` ${$t("ya5vrn5", "一站式工作")}`), _c('br'), _vm._v(`${$t("aucsqy4", "协作平台")} `)]), _c('p', {
    staticClass: "font-sans text-[10px] text-white/30 tracking-[0.25em] mb-10 uppercase"
  }, [_vm._v(` ${$t("78a1spc", "杭州绿云软件股份有限公司")} `)]), _c('p', {
    staticClass: "font-sans text-sm text-white/40 leading-relaxed max-w-xs"
  }, [_vm._v(` ${$t("5ta8t629", "作为酒店数字化生态中枢，深度聚合绿云 PMS、Oracle Hospitality、数据与营销四大核心业务。基于统一身份认证，为全员提供高效、安全的专属工作入口。")} `)])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "relative z-10 space-y-4"
  }, [_c('p', {
    staticClass: "font-sans text-[10px] text-white/30 tracking-widest mb-5 uppercase"
  }, [_vm._v(` ${$t("co3ob74", "忘记密码")} `)]), _c('div', {
    staticClass: "flex items-center space-x-3"
  }, [_c('div', {
    staticClass: "forget-step-dot forget-step-dot--active"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "font-sans text-xs text-white/70"
  }, [_vm._v(` ${$t("exld2z7", "手机 / 邮箱")} `)])]), _c('div', {
    staticClass: "flex items-center space-x-3"
  }, [_c('div', {
    staticClass: "forget-step-dot forget-step-dot--active"
  }, [_vm._v("2")]), _c('span', {
    staticClass: "font-sans text-xs text-white/70"
  }, [_vm._v(` ${$t("8mg9yc5", "发送验证码")} `)])]), _c('div', {
    staticClass: "flex items-center space-x-3"
  }, [_c('div', {
    staticClass: "forget-step-dot forget-step-dot--active"
  }, [_vm._v("3")]), _c('span', {
    staticClass: "font-sans text-xs text-white/70"
  }, [_vm._v(` ${$t("ai7i2u4", "修改密码")} `)])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex items-center space-x-2 mb-3"
  }, [_c('span', {
    staticClass: "w-1.5 h-1.5 rounded-full animate-pulse",
    staticStyle: {
      "background-color": "#785a1a"
    }
  }), _c('span', {
    staticClass: "font-sans text-[10px] text-white/30 tracking-widest"
  }, [_vm._v($t("s0e17vc", "iWork 服务运行正常"))])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex items-center space-x-2.5 lg:hidden"
  }, [_c('div', {
    staticClass: "w-7 h-7 rounded-lg flex items-center justify-center",
    staticStyle: {
      "background-color": "#785a1a"
    }
  }, [_c('img', {
    staticClass: "w-[16px] h-[16px]",
    attrs: {
      "src": require("@/assets/iwork-logo.png"),
      "alt": "",
      "aria-hidden": "true"
    }
  })]), _c('span', {
    staticClass: "font-serif text-on-surface text-lg"
  }, [_vm._v("iWork")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "font-sans text-xs tracking-[0.3em] text-secondary mb-3 uppercase"
  }, [_vm._v(` ${$t("9ukqxuc", "iWork · 忘记密码")} `)]), _c('h2', {
    staticClass: "text-4xl font-serif tracking-tight text-on-surface mb-3"
  }, [_vm._v(` ${$t("co3ob74", "忘记密码")} `)]), _c('p', {
    staticClass: "font-sans text-sm text-on-surface-variant"
  }, [_vm._v(` ${$t("9ydvae8", "重置你的登录密码")} `)])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tip"
  }, [_c('p', {
    staticClass: "tip_content"
  }, [_vm._v(` ${$t("4tppx119", "密码要求（至少8位，包含大小写字母、数字、符号） 安全建议：避免使用生日、连续数字等弱密码")} `)])]);
}];
export { render, staticRenderFns };